<div class="card card-outline">
    <div class="card-header d-flex align-items-center">
        <h6 class="card-title mb-0 mr-3">
            Custos de equipe e outros servidores
        </h6>
        <button type="button" class="btn btn-sm btn-success" (click)="incluir()" *ngIf="!visualizar">
            <i class="fas fa-plus"></i>
        </button>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-12">
                <div class="mat-elevation-z1">
                    <table mat-table [dataSource]="custoEquipeDataSource">

                        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-light"></tr>

                        <ng-container matColumnDef="nomeAgente">
                            <th mat-header-cell *matHeaderCellDef>Nome</th>
                            <td mat-cell *matCellDef="let element">{{ element.nomeAgente }}</td>
                        </ng-container>

                        <ng-container matColumnDef="dataInicio">
                            <th mat-header-cell *matHeaderCellDef>Data Inicial</th>
                            <td mat-cell *matCellDef="let element">{{ element.dataInicio | date:'dd/MM/yyyy' }}</td>
                        </ng-container>

                        <ng-container matColumnDef="dataFim">
                            <th mat-header-cell *matHeaderCellDef>Data Final</th>
                            <td mat-cell *matCellDef="let element">{{ element.dataFim | date:'dd/MM/yyyy' }}</td>
                        </ng-container>

                        <ng-container matColumnDef="diasCorridos">
                            <th mat-header-cell *matHeaderCellDef>Dias Corridos</th>
                            <td mat-cell *matCellDef="let element">{{ element.diasCorridos }}</td>
                        </ng-container>

                        <ng-container matColumnDef="salario">
                            <th mat-header-cell *matHeaderCellDef>Salário</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.salario > 0 ? (element.salario |
                                currency:'BRL':'symbol-narrow':'1.2-2') : '—' }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="custoFinal">
                            <th mat-header-cell *matHeaderCellDef>Custo Final</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.custoFinal > 0 ? (element.custoFinal |
                                currency:'BRL':'symbol-narrow':'1.2-2') : '—' }}
                            </td>
                        </ng-container>

                        <ng-container cdkColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let element" class="block">
                                <div class="btn-group">
                                    <button type="button" class="btn btn-primary btn-xs text-left" *ngIf="!visualizar"
                                        (click)="editar(element)">
                                        <i class="fas fa-pen"></i>
                                    </button>
                                    <button type="button" class="btn btn-danger btn-xs text-left ml-1"
                                        *ngIf="!visualizar" (click)="excluir(element.id)">
                                        <i class="fas fa-trash-alt"></i>
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>

                    <h5 [hidden]="!custoEquipeSemDados" class="table-no-data">Nenhum custo de equipe cadastrado</h5>
                </div>
            </div>
            <div class="col-md-12">
                <div class="text-left mt-2 font-weight-bold">
                    Subtotal: {{ calcularSubtotal() | currency:'BRL':'symbol-narrow':'1.2-2' }}
                </div>
            </div>
        </div>
    </div>
</div>